import { Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";

const LINKS = [
  { to: "/weddings", label: "Weddings" },
  { to: "/portfolio", label: "Portfolio" },
  { to: "/collections/major-events", label: "Events" },
  { to: "/shop", label: "Prints" },
  { to: "/gallery", label: "Time-Lapses" },
  { to: "/collections/hurricane-helene", label: "Helene" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const loc = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => setOpen(false), [loc.pathname]);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled ? "glass" : "bg-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2">
          <span className="font-mono text-[0.7rem] tracking-[0.35em] text-amber-glow">SCOTT</span>
          <span className="font-serif text-xl tracking-wide">Burton</span>
        </Link>

        <div className="hidden md:flex items-center gap-4 lg:gap-6">
          {LINKS.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className={`link-underline text-[0.82rem] tracking-wide whitespace-nowrap transition-colors ${
                loc.pathname === l.to ? "text-amber-glow" : "text-neutral-300 hover:text-white"
              }`}
            >
              {l.label}
            </Link>
          ))}
          <Link
            to="/incognito"
            data-testid="nav-incognito"
            className="text-[0.82rem] tracking-wide whitespace-nowrap text-amber-glow border border-amber-glow/40 rounded-full px-3 py-1 hover:bg-amber-glow/10 transition-colors"
          >
            Incognito
          </Link>
          <Link
            to="/account"
            data-testid="nav-account"
            className="text-sm border border-white/15 rounded-full px-4 py-1.5 hover:border-amber-glow/60 hover:text-amber-glow transition-colors"
          >
            My Orders
          </Link>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden text-white"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </nav>

      {open && (
        <div className="md:hidden glass border-t border-white/5 px-6 py-6 flex flex-col gap-4">
          <Link to="/incognito" data-testid="nav-m-incognito" className="text-amber-glow text-lg font-serif">Incognito Paparazzi</Link>
          {LINKS.concat({ to: "/account", label: "My Orders" }).map((l) => (
            <Link key={l.to} to={l.to} data-testid={`nav-m-${l.label.toLowerCase()}`} className="text-neutral-200 text-lg font-serif">
              {l.label}
            </Link>
          ))}
        </div>
      )}
    </header>
  );
};
